/*eslint-disable no-useless-constructor */
///*eslint-disable jsx-a11y/no-static-element-interactions */
///*eslint-disable jsx-a11y/click-events-have-key-events */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { Component, useEffect, useState } from 'react';
import { Container, Row, Col, OverlayTrigger, Popover } from 'react-bootstrap';
import { connect, useSelector } from 'react-redux';
import { withTranslation } from 'react-i18next';
import '../RegistrationSetup/Registrationsetup.scss';
import MasterPermissions from '../../api/MasterPermissions';
import CookiesService from '../../shared/CookiesService';
import Greetings from '../../shared/greetings';
import { DashboardIcons } from '../../img/GlobalSVG';
import Feature from '../../../services/feature';
import { USE_PERSONA_FRAMEWORK } from '../../../constants';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from '@material-ui/core';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Admin/api/APIEndpoints';

const AdminDashboard = (props) => {
  const navigate = useNavigate();
  const [getNotificationCount, setGetNotificationCount] = useState([]);
  const [viewEstimateCost, setviewEstimateCost] = useState(false);
  const { Features_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  console.log('********** Features_Setting', Features_Setting);
  const FEATURES = Features_Setting;
  const [viewProviderSelfRegistration, setViewProviderSelfRegistration] =
    useState(true);
  const [viewEnrollmentRequests, setViewEnrollmentRequests] = useState(false);
  const [viewDocuments, setViewDocuments] = useState(false);
  const [viewHelpDocuments, setViewHelpDocuments] = useState(false);
  useEffect(() => {
    const providerSelfRegistrationFlag =
      FEATURES &&
      FEATURES?.find((feature) => feature.Name === 'ProviderSelfRegistration');
    providerSelfRegistrationFlag && providerSelfRegistrationFlag.Status === true
      ? setViewProviderSelfRegistration(true)
      : setViewProviderSelfRegistration(false);

    //Check Send Document
    const sendDocumentFlag =
      FEATURES && FEATURES?.find((feature) => feature.Name === 'SendDocument');
    sendDocumentFlag && sendDocumentFlag.Status === true
      ? setViewDocuments(true)
      : setViewDocuments(false);
    //check for Enrollment Requests module feature enablement
    const memberEnrollmentRequestsFlag =
      FEATURES &&
      FEATURES?.find(
        (feature) => feature.Name === 'EnrollmentLifeChangeEventAdmin',
      );
    memberEnrollmentRequestsFlag && memberEnrollmentRequestsFlag.Status === true
      ? setViewEnrollmentRequests(true)
      : setViewEnrollmentRequests(false);
    //Check Manage Help Documents
    const manageHelpDocumentsFlag =
      FEATURES &&
      FEATURES?.find((feature) => feature.Name === 'ManageHelpDocuments');
    manageHelpDocumentsFlag && manageHelpDocumentsFlag.Status === true
      ? setViewHelpDocuments(true)
      : setViewHelpDocuments(false);
  }, [FEATURES]);
  //getNotificationcountapi
  const notificationCountList = async () => {
    try {
      const responseNotification = await axiosInstance.get(
        APIEndpoints.getNotificationcountapi(),
      );
      const MessageCounts =
        responseNotification.data.Response.ResponseObectForNotification
          .MessageCount;
      const MessageDetails =
        responseNotification.data.Response.ResponseObectForNotification
          .MessageDetail;
      setGetNotificationCount(MessageCounts);
    } catch (error) {
      return;
    }
  };

  useEffect(() => {
    const estimateCostFlag = FEATURES?.find(
      (feature) => feature.Name === 'EstimateCostAdmin',
    );
    estimateCostFlag && estimateCostFlag.Status === true
      ? setviewEstimateCost(true)
      : setviewEstimateCost(false);
    notificationCountList();
  }, []);

  //Members
  const ManageMember = () => {
    manageMemberTool = false;
    navigate('/admin/member-management');
  };
  const ConfigureRegistration = () => {
    configureRegistrationTool = false;
    navigate('/admin/registration-setup');
  };
  const ResetEmail = () => {
    resetEmailTool = false;
    navigate('/admin/email-reset');
  };
  const ResetPassword = () => {
    resetPasswordTool = false;
    navigate('/admin/password-reset');
  };
  const Preferences = () => {
    portalSettingTool = false;
    navigate('/admin/preferences');
  };

  //Member Experience
  const ApplyBranding = () => {
    navigate('/admin/white-labeling');
  };
  const ManageResources = () => {
    manageResourceTool = false;
    navigate('/admin/configure-resources');
  };
  const ManageContacts = () => {
    manageContactsTool = false;
    navigate('/admin/contacts');
  };
  const ConfigureLinks = () => {
    configureLinksTool = false;
    navigate('/admin/configure-links');
  };
  const ConfigurePages = () => {
    configurePagesTool = false;
    navigate('/admin/configure-pages');
  };
  const ConfigureSocialMedia = () => {
    configureSocialMediaTool = false;
    navigate('/admin/configure-socialmedia');
  };

  //Admin Users
  const ManageUsers = () => {
    manageUsersTool = false;
    navigate('/admin/user-management');
  };
  const CreateUser = () => {
    createUserTool = false;
    if (USE_PERSONA_FRAMEWORK) {
      navigate('/admin/create-new-user-new');
    } else {
      navigate('/admin/create-new-user');
    }
  };
  const PermissionGroup = () => {
    permissionGroupTool = false;
    navigate('/admin/user-group');
  };
  const EnrollmentRules = () => {
    EnrollmentRulesTool = false;
    navigate('/admin/enrollment-rules');
  };
  const SecuritySettings = () => {
    securitySettingTool = false;
    navigate('/admin/security-settings');
  };
  const PriceCompare = () => {
    navigate('/admin/price-compare');
  };
  const Configuration = () => {
    adminConfigurationTool = false;
    navigate('/admin/configuration');
  };
  const Reports = () => {
    ReportsTool = false;
    navigate('/admin/reports');
  };
  const ReportSetting = () => {
    ReportSettingTool = false;
    navigate('/admin/report-setting');
  };

  const searchClaims = () => {
    adminConfigurationTool = false;
    navigate('/admin/search-claims');
  };

  const Documents = () => {
    documentTool = false;
    navigate('/admin/Messages-Documents', {
      state: {
        comingFrom: 'messages',
        notificationCount: getNotificationCount,
      },
    });
  };

  const SelfAccountUnlockConfiguration = () => {
    documentTool = false;
    navigate(`/admin/account-unlock`, {
      state: {
        name: 'dashboard',
      },
    });
  };

  const ApprovalLink = () => {
    documentTool = false;
    navigate('/admin/approvals');
  };

  const ManageHelpDocuments = () => {
    manageHelpDocumentsTool = false;
    navigate('/admin/manage-help-documents');
  };

  const toolTipOverlayFunction = ({ show, header, content, cardName }) => {
    return (
      <OverlayTrigger
        show={show}
        placement="bottom"
        delay={{ show: 200, hide: 450 }}
        overlay={
          <Popover>
            <Popover.Content>
              <div>
                <span className="tooltip-header">{header}</span>
                <br />
                <span className="tooltip-content-text">{content}</span>
              </div>
            </Popover.Content>
          </Popover>
        }
      >
        <h5>{cardName}</h5>
      </OverlayTrigger>
    );
  };

  let manageMember = false;
  let configureRegistration = false;
  let manageUsers = false;
  let createUser = false;
  let manageResources = false;
  let configureLinks = false;
  let manageContacts = false;
  let configurePages = false;
  let viewPortalSettings = false;
  let configureSocialMedia = false;
  let viewReportsSetting = false;
  let viewSearchClaims = false;
  let viewEnrollmentRules = false;

  let manageMemberTool = false;
  let configureRegistrationTool = false;
  let manageUsersTool = false;
  let createUserTool = false;
  let manageResourceTool = false;
  let configureLinksTool = false;
  let manageContactsTool = false;
  let configurePagesTool = false;
  let resetPasswordTool = false;
  let resetEmailTool = false;
  let configureSocialMediaTool = false;
  let securitySettingTool = false;
  let permissionGroupTool = false;
  let EnrollmentRulesTool = false;
  let portalSettingTool = false;
  const estimateCostTool = false;
  let adminConfigurationTool = false;
  let ReportsTool = false;
  let ReportSettingTool = false;
  let documentTool = false;
  let manageHelpDocumentsTool = false;

  let showEnrollmentApprovals = false;
  const showAffiliationApprovals = true; //#TODO : Based on permission update this variable

  console.log('MasterPermissions', MasterPermissions);

  const SuperUser = props.userData;
  if (
    MasterPermissions.CheckPermission('Mandatory Member Details') ||
    (MasterPermissions.CheckPermission('Default Search') &&
      MasterPermissions.CheckPermission('View Member Record'))
  ) {
    manageMember = true;
  }
  if (MasterPermissions.CheckPermission('View Registration Configuration')) {
    configureRegistration = true;
  }
  if (
    MasterPermissions.CheckPermission('View Insurer Users') ||
    MasterPermissions.CheckPermission('View Client Users') ||
    MasterPermissions.CheckPermission('View Broker Users') ||
    MasterPermissions.CheckPermission('View Provider Users') ||
    MasterPermissions.CheckPermission('View Members/Dependents Users')
  ) {
    manageUsers = true;
  }
  if (
    MasterPermissions.CheckPermission('Create Insurer Users') ||
    MasterPermissions.CheckPermission('Create Client Users') ||
    MasterPermissions.CheckPermission('Create Broker Users') ||
    MasterPermissions.CheckPermission('Create Provider Users')
  ) {
    createUser = true;
  }
  if (MasterPermissions.CheckPermission('View Resource')) {
    manageResources = true;
  }
  if (MasterPermissions.CheckPermission('View Link')) {
    configureLinks = true;
  }
  if (MasterPermissions.CheckPermission('View Contact')) {
    manageContacts = true;
  }
  if (MasterPermissions.CheckPermission('View Page')) {
    configurePages = true;
  }

  if (MasterPermissions.CheckPermission('View System Preference')) {
    viewPortalSettings = true;
  }

  if (MasterPermissions.CheckPermission('View Configure Social Media')) {
    configureSocialMedia = true;
  }

  if (MasterPermissions.CheckPermission('Reports')) {
    viewReportsSetting = true;
  }

  if (MasterPermissions.CheckPermission('View Claim Search')) {
    viewSearchClaims = true;
  }

  if (
    (MasterPermissions.CheckPermission('Approve Enrollment') &&
      MasterPermissions.CheckPermission('Employer Approval')) ||
    (MasterPermissions.CheckPermission('Approve Enrollment') &&
      MasterPermissions.CheckPermission('Insurer Approval'))
  ) {
    showEnrollmentApprovals = true;
  }

  if (MasterPermissions.CheckPermission('Configure Enrollment Rules')) {
    viewEnrollmentRules = true;
  }

  const { t } = props;
  return (
    <Container fluid>
      <div className="d-none d-md-block d-lg-block">
        <h1 id="greetings-time">{t('welcome_text')}</h1>
        <p>
          {Greetings.getGreetings()},{' '}
          {CookiesService.get('Firstname') +
            ' ' +
            CookiesService.get('Lastname')}
        </p>
      </div>
      {(manageMember || configureRegistration) && (
        <div className="member-modules">
          <h3 className="admin-header">
            {t('admin.dashboard_modules.members.module')}
          </h3>
          <Row className="admin-dashboard">
            {manageMember && (
              <Col md={2}>
                <Tooltip
                  className="my-dashboard-tooltip"
                  placement="bottom"
                  title={
                    <div className="dashboard-tooltip-container">
                      <div className="dashboard-tooltip-header">
                        {t('admin.dashboard_modules.members.manage_member')}
                      </div>
                      <div>
                        {t(
                          'admin.dashboard_modules.members.manage_member_content',
                        )}
                      </div>
                    </div>
                  }
                  id={`tooltip-${1}`}
                  arrow
                >
                  <div
                    className="admin-box"
                    onClick={ManageMember}
                    onMouseEnter={() => (manageMemberTool = true)}
                    onMouseLeave={() => (manageMemberTool = false)}
                  >
                    <DashboardIcons.PersonLockSVG
                      className="svg-icons"
                      subClassName="info-svg-icons"
                    />
                    {toolTipOverlayFunction({
                      show: manageMemberTool,
                      header: t(
                        'admin.dashboard_modules.members.manage_member',
                      ),
                      content: t(
                        'admin.dashboard_modules.members.manage_member_content',
                      ),
                      cardName: t(
                        'admin.dashboard_modules.members.manage_member',
                      ),
                    })}
                  </div>
                </Tooltip>
              </Col>
            )}
            {configureRegistration && (
              <Col md={2}>
                <Tooltip
                  className="my-dashboard-tooltip"
                  placement="bottom"
                  title={
                    <div className="dashboard-tooltip-container">
                      <div className="dashboard-tooltip-header">
                        {t('admin.dashboard_modules.members.configure_reg')}
                      </div>
                      <div>
                        {t(
                          'admin.dashboard_modules.members.configure_reg_content',
                        )}
                      </div>
                    </div>
                  }
                  id={`tooltip-${2}`}
                  arrow
                >
                  <div
                    className="admin-box"
                    onClick={ConfigureRegistration}
                    onMouseEnter={() => (configureRegistrationTool = true)}
                    onMouseLeave={() => (configureRegistrationTool = false)}
                  >
                    <DashboardIcons.GearEditSVG className="svg-icons" />
                    {toolTipOverlayFunction({
                      show: configureRegistrationTool,
                      header: t(
                        'admin.dashboard_modules.members.configure_reg',
                      ),
                      content: t(
                        'admin.dashboard_modules.members.configure_reg_content',
                      ),
                      cardName: t(
                        'admin.dashboard_modules.members.configure_reg',
                      ),
                    })}
                  </div>
                </Tooltip>
              </Col>
            )}
            {SuperUser?.SuperUser === true && (
              <Col md={2}>
                <Tooltip
                  className="my-dashboard-tooltip"
                  placement="bottom"
                  title={
                    <div className="dashboard-tooltip-container">
                      <div className="dashboard-tooltip-header">
                        {t('admin.dashboard_modules.members.reset_email')}
                      </div>
                      <div>
                        {t(
                          'admin.dashboard_modules.members.reset_email_content',
                        )}
                      </div>
                    </div>
                  }
                  id={`tooltip-${2}`}
                  arrow
                >
                  <div
                    className="admin-box"
                    onClick={ResetEmail}
                    onMouseEnter={() => (resetEmailTool = true)}
                    onMouseLeave={() => (resetEmailTool = false)}
                  >
                    <DashboardIcons.EnvelopeSVG className="svg-icons" />
                    {toolTipOverlayFunction({
                      show: resetEmailTool,
                      header: t('admin.dashboard_modules.members.reset_email'),
                      content: t(
                        'admin.dashboard_modules.members.reset_email_content',
                      ),
                      cardName: t(
                        'admin.dashboard_modules.members.reset_email',
                      ),
                    })}
                  </div>
                </Tooltip>
              </Col>
            )}
            {SuperUser?.SuperUser === true && (
              <Col md={2}>
                <Tooltip
                  className="my-dashboard-tooltip"
                  placement="bottom"
                  title={
                    <div className="dashboard-tooltip-container">
                      <div className="dashboard-tooltip-header">
                        {t('admin.dashboard_modules.members.reset_password')}
                      </div>
                      <div>
                        {t(
                          'admin.dashboard_modules.members.reset_password_content',
                        )}
                      </div>
                    </div>
                  }
                  id={`tooltip-${3}`}
                  arrow
                >
                  <div
                    className="admin-box"
                    onClick={ResetPassword}
                    onMouseEnter={() => (resetPasswordTool = true)}
                    onMouseLeave={() => (resetPasswordTool = false)}
                  >
                    <DashboardIcons.PersonLockSVG
                      className="svg-icons"
                      subClassName="info-svg-icons"
                    />
                    {toolTipOverlayFunction({
                      show: resetPasswordTool,
                      header: t(
                        'admin.dashboard_modules.members.reset_password',
                      ),
                      content: t(
                        'admin.dashboard_modules.members.reset_password_content',
                      ),
                      cardName: t(
                        'admin.dashboard_modules.members.reset_password',
                      ),
                    })}
                  </div>
                </Tooltip>
              </Col>
            )}
            {SuperUser?.SuperUser === true && (
              <Col md={2}>
                <Tooltip
                  className="my-dashboard-tooltip"
                  placement="bottom"
                  title={
                    <div className="dashboard-tooltip-container">
                      <div className="dashboard-tooltip-header">
                        {t('admin.dashboard_modules.members.portal_settings')}
                      </div>
                      <div>
                        {t(
                          'admin.dashboard_modules.members.portal_settings_content',
                        )}
                      </div>
                    </div>
                  }
                  id={`tooltip-${4}`}
                  arrow
                >
                  <div
                    className="admin-box"
                    onClick={Preferences}
                    onMouseEnter={() => (portalSettingTool = true)}
                    onMouseLeave={() => (portalSettingTool = false)}
                  >
                    <DashboardIcons.PreferencesSVG className="svg-icons" />
                    {toolTipOverlayFunction({
                      show: portalSettingTool,
                      header: t(
                        'admin.dashboard_modules.members.portal_settings',
                      ),
                      content: t(
                        'admin.dashboard_modules.members.portal_settings_content',
                      ),
                      cardName: t(
                        'admin.dashboard_modules.members.portal_settings',
                      ),
                    })}
                  </div>
                </Tooltip>
              </Col>
            )}
          </Row>
        </div>
      )}

      {(manageResources ||
        manageContacts ||
        configureLinks ||
        configurePages ||
        SuperUser?.SuperUser === true) && (
        <div>
          <h3 className="admin-header">
            {t('admin.dashboard_modules.member_experience.module')}
          </h3>
          {(manageResources ||
            manageContacts ||
            configureLinks ||
            configurePages ||
            SuperUser?.SuperUser === true) && (
            <Row className="admin-dashboard mar-b-5">
              {/*<Col md={2}>
                <div className="admin-box" onClick={this.ApplyBranding} onMouseEnter={() => this.setState({ applyBrandingTool: true })} onMouseLeave={() => this.setState({ applyBrandingTool: false })}>
                <DashboardIcons.PersonLockSVG />
                  {toolTipOverlayFunction({ show: applyBrandingTool, header: 'Apply Branding', content: t('admin.dashboard_modules.member_experience.apply_branding_content'), cardName: 'Apply Branding' })}
                </div>
              </Col> */}
              {manageResources && (
                <Col md={2}>
                  <Tooltip
                    className="my-dashboard-tooltip"
                    placement="bottom"
                    title={
                      <div className="dashboard-tooltip-container">
                        <div className="dashboard-tooltip-header">
                          {t(
                            'admin.dashboard_modules.member_experience.resources',
                          )}
                        </div>
                        <div>
                          {t(
                            'admin.dashboard_modules.member_experience.manage_resource_content',
                          )}
                        </div>
                      </div>
                    }
                    id={`tooltip-${5}`}
                    arrow
                  >
                    <div
                      className="admin-box"
                      onClick={ManageResources}
                      onMouseEnter={() => (manageResourceTool = true)}
                      onMouseLeave={() => (manageResourceTool = false)}
                    >
                      <DashboardIcons.ManageResourcesSVG className="svg-icons" />
                      {toolTipOverlayFunction({
                        show: manageResourceTool,
                        header: t(
                          'admin.dashboard_modules.member_experience.resources',
                        ),
                        content: t(
                          'admin.dashboard_modules.member_experience.manage_resource_content',
                        ),
                        cardName: t(
                          'admin.dashboard_modules.member_experience.resources',
                        ),
                      })}
                    </div>
                  </Tooltip>
                </Col>
              )}
              {manageContacts && (
                <Col md={2}>
                  <Tooltip
                    className="my-dashboard-tooltip"
                    placement="bottom"
                    title={
                      <div className="dashboard-tooltip-container">
                        <div className="dashboard-tooltip-header">
                          {t(
                            'admin.dashboard_modules.member_experience.contacts',
                          )}
                        </div>
                        <div>
                          {t(
                            'admin.dashboard_modules.member_experience.manage_contact_content',
                          )}
                        </div>
                      </div>
                    }
                    id={`tooltip-${6}`}
                    arrow
                  >
                    <div
                      className="admin-box"
                      onClick={ManageContacts}
                      onMouseEnter={() => (manageContactsTool = true)}
                      onMouseLeave={() => (manageContactsTool = false)}
                    >
                      <DashboardIcons.ManageContactsSVG className="svg-icons" />
                      {toolTipOverlayFunction({
                        show: manageContactsTool,
                        header: t(
                          'admin.dashboard_modules.member_experience.contacts',
                        ),
                        content: t(
                          'admin.dashboard_modules.member_experience.manage_contact_content',
                        ),
                        cardName: t(
                          'admin.dashboard_modules.member_experience.contacts',
                        ),
                      })}
                    </div>
                  </Tooltip>
                </Col>
              )}
              {configureLinks && (
                <Col md={2}>
                  <Tooltip
                    className="my-dashboard-tooltip"
                    placement="bottom"
                    title={
                      <div className="dashboard-tooltip-container">
                        <div className="dashboard-tooltip-header">
                          {t('admin.dashboard_modules.member_experience.links')}
                        </div>
                        <div>
                          {t(
                            'admin.dashboard_modules.member_experience.configure_links_content',
                          )}
                        </div>
                      </div>
                    }
                    id={`tooltip-${7}`}
                    arrow
                  >
                    <div
                      className="admin-box"
                      onClick={ConfigureLinks}
                      onMouseEnter={() => (configureLinksTool = true)}
                      onMouseLeave={() => (configureLinksTool = false)}
                    >
                      <DashboardIcons.ConfigureLinksSVG className="svg-icons" />
                      {toolTipOverlayFunction({
                        show: configureLinksTool,
                        header: t(
                          'admin.dashboard_modules.member_experience.links',
                        ),
                        content: t(
                          'admin.dashboard_modules.member_experience.configure_links_content',
                        ),
                        cardName: t(
                          'admin.dashboard_modules.member_experience.links',
                        ),
                      })}
                    </div>
                  </Tooltip>
                </Col>
              )}
              {configurePages && (
                <Col md={2}>
                  <Tooltip
                    className="my-dashboard-tooltip"
                    placement="bottom"
                    title={
                      <div className="dashboard-tooltip-container">
                        <div className="dashboard-tooltip-header">
                          {t('admin.dashboard_modules.member_experience.pages')}
                        </div>
                        <div>
                          {t(
                            'admin.dashboard_modules.member_experience.configure_pages_content',
                          )}
                        </div>
                      </div>
                    }
                    id={`tooltip-${8}`}
                    arrow
                  >
                    <div
                      className="admin-box"
                      onClick={ConfigurePages}
                      onMouseEnter={() => (configurePagesTool = true)}
                      onMouseLeave={() => (configurePagesTool = false)}
                    >
                      <DashboardIcons.PreferencesSVG className="svg-icons" />
                      {toolTipOverlayFunction({
                        show: configurePagesTool,
                        header: t(
                          'admin.dashboard_modules.member_experience.pages',
                        ),
                        content: t(
                          'admin.dashboard_modules.member_experience.configure_pages_content',
                        ),
                        cardName: t(
                          'admin.dashboard_modules.member_experience.pages',
                        ),
                      })}
                    </div>
                  </Tooltip>
                </Col>
              )}
              {SuperUser?.SuperUser === true && (
                <Col md={2}>
                  <Tooltip
                    className="my-dashboard-tooltip"
                    placement="bottom"
                    title={
                      <div className="dashboard-tooltip-container">
                        <div className="dashboard-tooltip-header">
                          {t(
                            'admin.dashboard_modules.member_experience.social_media',
                          )}
                        </div>
                        <div>
                          {t(
                            'admin.dashboard_modules.member_experience.configure_social_content',
                          )}
                        </div>
                      </div>
                    }
                    id={`tooltip-${9}`}
                    arrow
                  >
                    <div
                      className="admin-box"
                      onClick={ConfigureSocialMedia}
                      onMouseEnter={() => (configureSocialMediaTool = true)}
                      onMouseLeave={() => (configureSocialMediaTool = false)}
                    >
                      <DashboardIcons.SocialMediaSVG className="svg-icons" />
                      {toolTipOverlayFunction({
                        show: configureSocialMediaTool,
                        header: t(
                          'admin.dashboard_modules.member_experience.social_media',
                        ),
                        content: t(
                          'admin.dashboard_modules.member_experience.configure_social_content',
                        ),
                        cardName: t(
                          'admin.dashboard_modules.member_experience.social_media',
                        ),
                      })}
                    </div>
                  </Tooltip>
                </Col>
              )}
            </Row>
          )}
          {SuperUser?.SuperUser === true && (
            <Row className="admin-dashboard mar-b-5">
              {SuperUser?.SuperUser === true && (
                <Col md={2}>
                  <Tooltip
                    className="my-dashboard-tooltip"
                    placement="bottom"
                    title={
                      <div className="dashboard-tooltip-container">
                        <div className="dashboard-tooltip-header">
                          {t(
                            'admin.dashboard_modules.admin_users.security_settings',
                          )}
                        </div>
                        <div>
                          {t(
                            'admin.dashboard_modules.admin_users.security_setting_content',
                          )}
                        </div>
                      </div>
                    }
                    id={`tooltip-${10}`}
                    arrow
                  >
                    <div
                      className="admin-box"
                      onClick={SecuritySettings}
                      onMouseEnter={() => (securitySettingTool = true)}
                      onMouseLeave={() => (securitySettingTool = false)}
                    >
                      <DashboardIcons.SecuritySettingsSVG className="svg-icons" />
                      {toolTipOverlayFunction({
                        show: securitySettingTool,
                        header: t(
                          'admin.dashboard_modules.admin_users.security_settings',
                        ),
                        content: t(
                          'admin.dashboard_modules.admin_users.security_setting_content',
                        ),
                        cardName: t(
                          'admin.dashboard_modules.admin_users.security_settings',
                        ),
                      })}
                    </div>
                  </Tooltip>
                </Col>
              )}
              {viewHelpDocuments && SuperUser?.SuperUser === true && (
                <Col md={2}>
                  <Tooltip
                    className="my-dashboard-tooltip"
                    placement="bottom"
                    title={
                      <div className="dashboard-tooltip-container">
                        <div className="dashboard-tooltip-header">
                          {t(
                            'admin.dashboard_modules.admin_users.manage_help_document',
                          )}
                        </div>
                        <div>
                          {t(
                            'admin.dashboard_modules.admin_users.manage_help_document_content',
                          )}
                        </div>
                      </div>
                    }
                    id={`tooltip-${11}`}
                    arrow
                  >
                    <div
                      className="admin-box"
                      onClick={ManageHelpDocuments}
                      onMouseEnter={() => (manageHelpDocumentsTool = true)}
                      onMouseLeave={() => (manageHelpDocumentsTool = false)}
                    >
                      <DashboardIcons.ManageHelpDocumentsSVG className="help-document-svg-icons" />
                      {toolTipOverlayFunction({
                        show: manageHelpDocumentsTool,
                        header: t(
                          'admin.dashboard_modules.admin_users.manage_help_document',
                        ),
                        content: t(
                          'admin.dashboard_modules.admin_users.manage_help_document_content',
                        ),
                        cardName: t(
                          'admin.dashboard_modules.admin_users.manage_help_document',
                        ),
                      })}
                    </div>
                  </Tooltip>
                </Col>
              )}
              {/*<Feature name="EstimateCostAdmin">
                {MasterPermissions.CheckPermission(
                  'Access to Cost Estimator Tool',
                ) &&
                  viewEstimateCost && (
                    <Col md={2}>
                      <Tooltip
                        className="my-dashboard-tooltip"
                        placement="bottom"
                        title={
                          <div className="dashboard-tooltip-container">
                            <div className="dashboard-tooltip-header">
                              {t(
                                'admin.dashboard_modules.admin_users.price_compare',
                              )}
                            </div>
                            <div>
                              {t(
                                'admin.dashboard_modules.admin_users.estimate_cost_content',
                              )}
                            </div>
                          </div>
                        }
                        id={`tooltip-${10}`}
                        arrow
                      >
                        <div
                          className="admin-box"
                          onClick={PriceCompare}
                          onMouseEnter={() => (estimateCostTool = true)}
                          onMouseLeave={() => (estimateCostTool = false)}
                        >
                          <DashboardIcons.PriceCompareSVG className="svg-icons" />
                          {toolTipOverlayFunction({
                            show: estimateCostTool,
                            header: t(
                              'admin.dashboard_modules.admin_users.price_compare',
                            ),
                            content: t(
                              'admin.dashboard_modules.admin_users.estimate_cost_content',
                            ),
                            cardName: t(
                              'admin.dashboard_modules.admin_users.price_compare',
                            ),
                          })}
                        </div>
                      </Tooltip>
                    </Col>
                  )}
              </Feature> */}
            </Row>
          )}
        </div>
      )}
      <div>
        <h3 className="admin-header">
          {t('admin.dashboard_modules.admin_users.module')}
        </h3>
        <Row className="admin-dashboard mar-b-5">
          {manageUsers && (
            <Col md={2}>
              <Tooltip
                className="my-dashboard-tooltip"
                placement="bottom"
                title={
                  <div className="dashboard-tooltip-container">
                    <div className="dashboard-tooltip-header">
                      {t('admin.dashboard_modules.admin_users.users')}
                    </div>
                    <div>
                      {t(
                        'admin.dashboard_modules.admin_users.manage_user_content',
                      )}
                    </div>
                  </div>
                }
                id={`tooltip-${11}`}
                arrow
              >
                <div
                  className="admin-box"
                  onClick={ManageUsers}
                  onMouseEnter={() => (manageUsersTool = true)}
                  onMouseLeave={() => (manageUsersTool = false)}
                >
                  <DashboardIcons.PersonLockSVG
                    className="svg-icons"
                    subClassName="info-svg-icons"
                  />
                  {toolTipOverlayFunction({
                    show: manageUsersTool,
                    header: t('admin.dashboard_modules.admin_users.users'),
                    content: t(
                      'admin.dashboard_modules.admin_users.manage_user_content',
                    ),
                    cardName: t('admin.dashboard_modules.admin_users.users'),
                  })}
                </div>
              </Tooltip>
            </Col>
          )}
          {createUser && manageUsers && (
            <Col md={2}>
              <Tooltip
                className="my-dashboard-tooltip"
                placement="bottom"
                title={
                  <div className="dashboard-tooltip-container">
                    <div className="dashboard-tooltip-header">
                      {t('admin.dashboard_modules.admin_users.create_user')}
                    </div>
                    <div>
                      {t(
                        'admin.dashboard_modules.admin_users.create_user_content',
                      )}
                    </div>
                  </div>
                }
                id={`tooltip-${12}`}
                arrow
              >
                <div
                  className="admin-box"
                  onClick={CreateUser}
                  onMouseEnter={() => (createUserTool = true)}
                  onMouseLeave={() => (createUserTool = false)}
                >
                  <DashboardIcons.GearEditSVG className="svg-icons" />
                  {toolTipOverlayFunction({
                    show: createUserTool,
                    header: t(
                      'admin.dashboard_modules.admin_users.create_user',
                    ),
                    content: t(
                      'admin.dashboard_modules.admin_users.create_user_content',
                    ),
                    cardName: t(
                      'admin.dashboard_modules.admin_users.create_user',
                    ),
                  })}
                </div>
              </Tooltip>
            </Col>
          )}
          <Col md={2}>
            <Tooltip
              className="my-dashboard-tooltip"
              placement="bottom"
              title={
                <div className="dashboard-tooltip-container">
                  <div className="dashboard-tooltip-header">
                    {t('admin.dashboard_modules.admin_users.permission_group')}
                  </div>
                  <div>
                    {t(
                      'admin.dashboard_modules.admin_users.permission_group_content',
                    )}
                  </div>
                </div>
              }
              id={`tooltip-${13}`}
              arrow
            >
              <div
                className="admin-box"
                onClick={PermissionGroup}
                onMouseEnter={() => (permissionGroupTool = true)}
                onMouseLeave={() => (permissionGroupTool = false)}
              >
                <DashboardIcons.EnvelopeSVG className="svg-icons" />
                {toolTipOverlayFunction({
                  show: permissionGroupTool,
                  header: t(
                    'admin.dashboard_modules.admin_users.permission_group',
                  ),
                  content: t(
                    'admin.dashboard_modules.admin_users.permission_group_content',
                  ),
                  cardName: t(
                    'admin.dashboard_modules.admin_users.permission_group',
                  ),
                })}
              </div>
            </Tooltip>
          </Col>
          {viewEnrollmentRequests &&
            (SuperUser?.SuperUser === true || viewEnrollmentRules) && (
              <Col md={2}>
                <Tooltip
                  className="my-dashboard-tooltip"
                  placement="bottom"
                  title={
                    <div className="dashboard-tooltip-container">
                      <div className="dashboard-tooltip-header">
                        {t(
                          'admin.dashboard_modules.admin_users.enrollment_rules',
                        )}
                      </div>
                      <div>
                        {t(
                          'admin.dashboard_modules.admin_users.enrollment_rules_content',
                        )}
                      </div>
                    </div>
                  }
                  id={`tooltip-${17}`}
                  arrow
                >
                  <div
                    className="admin-box"
                    onClick={EnrollmentRules}
                    onMouseEnter={() => (EnrollmentRulesTool = true)}
                    onMouseLeave={() => (EnrollmentRulesTool = false)}
                  >
                    <DashboardIcons.EnrollmentRulesSVG className="svg-icons" />
                    {toolTipOverlayFunction({
                      show: EnrollmentRulesTool,
                      header: t(
                        'admin.dashboard_modules.admin_users.enrollment_rules',
                      ),
                      content: t(
                        'admin.dashboard_modules.admin_users.enrollment_rules_content',
                      ),
                      cardName: t(
                        'admin.dashboard_modules.admin_users.enrollment_rules',
                      ),
                    })}
                  </div>
                </Tooltip>
              </Col>
            )}
          {SuperUser?.SuperUser === true && (
            <Col md={2}>
              <Tooltip
                className="my-dashboard-tooltip"
                placement="bottom"
                title={
                  <div className="dashboard-tooltip-container">
                    <div className="dashboard-tooltip-header">
                      {t(
                        'admin.dashboard_modules.admin_users.admin_configuration_module',
                      )}
                    </div>
                    <div>
                      {t(
                        'admin.dashboard_modules.admin_users.admin_configuration_content',
                      )}
                    </div>
                  </div>
                }
                id={`tooltip-${14}`}
                arrow
              >
                <div
                  className="admin-box"
                  onClick={Configuration}
                  onMouseEnter={() => (adminConfigurationTool = true)}
                  onMouseLeave={() => (adminConfigurationTool = false)}
                >
                  <DashboardIcons.AdminConfigurationSVG className="svg-icons" />
                  {toolTipOverlayFunction({
                    show: adminConfigurationTool,
                    header: t(
                      'admin.dashboard_modules.admin_users.admin_configuration_module',
                    ),
                    content: t(
                      'admin.dashboard_modules.admin_users.admin_configuration_content',
                    ),
                    cardName: t(
                      'admin.dashboard_modules.admin_users.admin_configuration_module',
                    ),
                  })}
                </div>
              </Tooltip>
            </Col>
          )}
        </Row>
        <Row className="admin-dashboard mar-b-5">
          {(SuperUser?.SuperUser === true || viewSearchClaims) && (
            <Col md={2}>
              <Tooltip
                className="my-dashboard-tooltip"
                placement="bottom"
                title={
                  <div className="dashboard-tooltip-container">
                    <div className="dashboard-tooltip-header">
                      {t(
                        'admin.dashboard_modules.admin_users.admin_search_claims_module',
                      )}
                    </div>
                    <div>
                      {t(
                        'admin.dashboard_modules.admin_users.admin_search_claims_content',
                      )}
                    </div>
                  </div>
                }
                id={`tooltip-${15}`}
                arrow
              >
                <div
                  className="admin-box"
                  onClick={searchClaims}
                  onMouseEnter={() => (adminConfigurationTool = true)}
                  onMouseLeave={() => (adminConfigurationTool = false)}
                >
                  <DashboardIcons.SearchSVG className="svg-icons" />
                  {toolTipOverlayFunction({
                    show: adminConfigurationTool,
                    header: t(
                      'admin.dashboard_modules.admin_users.admin_search_claims_module',
                    ),
                    content: t(
                      'admin.dashboard_modules.admin_users.admin_search_claims_content',
                    ),
                    cardName: t(
                      'admin.dashboard_modules.admin_users.admin_search_claims_module',
                    ),
                  })}
                </div>
              </Tooltip>
            </Col>
          )}
          {viewDocuments && (
            <Col md={2}>
              <Tooltip
                className="my-dashboard-tooltip"
                placement="bottom"
                title={
                  <div className="dashboard-tooltip-container">
                    <div className="dashboard-tooltip-header">
                      {t(
                        'admin.dashboard_modules.admin_users.admin_documents_Tail',
                      )}
                    </div>
                    <div>
                      {t(
                        'admin.dashboard_modules.admin_users.admin_documents_Tail_content',
                      )}
                    </div>
                  </div>
                }
                id={`tooltip-${15}`}
                arrow
              >
                <div
                  className="admin-box"
                  onClick={Documents}
                  onMouseEnter={() => (documentTool = true)}
                  onMouseLeave={() => (documentTool = false)}
                >
                  <DashboardIcons.DocumentsSVG className="svg-icons" />
                  {toolTipOverlayFunction({
                    show: documentTool,
                    header: t(
                      'admin.dashboard_modules.admin_users.admin_documents_Tail',
                    ),
                    content: t(
                      'admin.dashboard_modules.admin_users.admin_documents_Tail_content',
                    ),
                    cardName: t(
                      'admin.dashboard_modules.admin_users.admin_documents_Tail',
                    ),
                  })}
                </div>
              </Tooltip>
            </Col>
          )}
          {(viewProviderSelfRegistration ||
            (viewEnrollmentRequests && showEnrollmentApprovals) ||
            showAffiliationApprovals) && (
            <Col md={2}>
              <Tooltip
                className="my-dashboard-tooltip"
                placement="bottom"
                title={
                  <div className="dashboard-tooltip-container">
                    <div className="dashboard-tooltip-header">
                      {t(
                        'admin.dashboard_modules.admin_users.admin_approval_Tail',
                      )}
                    </div>
                    <div>
                      {t(
                        'admin.dashboard_modules.admin_users.admin_approval_Tail_content',
                      )}
                    </div>
                  </div>
                }
                id={`tooltip-${18}`}
                arrow
              >
                <div
                  className="admin-box"
                  onClick={ApprovalLink}
                  onMouseEnter={() => (documentTool = true)}
                  onMouseLeave={() => (documentTool = false)}
                >
                  <DashboardIcons.ApprovalSVG className="svg-icons" />
                  {toolTipOverlayFunction({
                    show: documentTool,
                    cardName: t(
                      'admin.dashboard_modules.admin_users.admin_approval_Tail',
                    ),
                  })}
                </div>
              </Tooltip>
            </Col>
          )}
          {SuperUser?.SuperUser === true && (
            <Col md={2}>
              <Tooltip
                className="my-dashboard-tooltip"
                placement="bottom"
                title={
                  <div className="dashboard-tooltip-container">
                    <div className="dashboard-tooltip-header">
                      {/*{t(
                        'admin.dashboard_modules.admin_users.self_account_unlock_configuration',
                      )} */}
                      {'Self Account Unlock'}
                    </div>

                    <div>
                      {'Self Account Unlock'}
                      {/*{t(
                        'admin.dashboard_modules.admin_users.self_account_unlock_configuration',
                      )} */}
                    </div>
                  </div>
                }
                id={`tooltip-${18}`}
                arrow
              >
                <div
                  className="admin-box"
                  onClick={SelfAccountUnlockConfiguration}
                  onMouseEnter={() => (documentTool = true)}
                  onMouseLeave={() => (documentTool = false)}
                >
                  <DashboardIcons.SelfAccountUnlockSvg className="svg-icons" />
                  {toolTipOverlayFunction({
                    show: documentTool,
                    cardName: 'Self Account Unlock',
                    //cardName: t(
                    //'admin.dashboard_modules.admin_users.self_account_unlock_configuration',
                    //),
                  })}
                </div>
              </Tooltip>
            </Col>
          )}
        </Row>
      </div>
      {(SuperUser?.SuperUser === true || viewReportsSetting) && (
        <div>
          <h3 className="admin-header">
            {t('admin.dashboard_modules.reports.module')}
          </h3>
          <Row className="admin-dashboard">
            <Col md={2}>
              <Tooltip
                className="my-dashboard-tooltip"
                placement="bottom"
                title={
                  <div className="dashboard-tooltip-container">
                    <div className="dashboard-tooltip-header">
                      {t('admin.dashboard_modules.reports.tile_text')}
                    </div>
                    <div>
                      {t(
                        'admin.dashboard_modules.admin_users.generate_reports',
                      )}
                    </div>
                  </div>
                }
                id={`tooltip-${16}`}
                arrow
              >
                <div
                  className="admin-box"
                  onClick={Reports}
                  onMouseEnter={() => (ReportsTool = true)}
                  onMouseLeave={() => (ReportsTool = false)}
                >
                  <DashboardIcons.ReportsSVG className="svg-icons" />
                  {toolTipOverlayFunction({
                    show: ReportsTool,
                    header: t('admin.dashboard_modules.reports.tile_text'),
                    content: t(
                      'admin.dashboard_modules.admin_users.generate_reports',
                    ),
                    cardName: t('admin.dashboard_modules.reports.tile_text'),
                  })}
                </div>
              </Tooltip>
            </Col>
            {SuperUser?.SuperUser === true && (
              <Col md={2}>
                <Tooltip
                  className="my-dashboard-tooltip"
                  placement="bottom"
                  title={
                    <div className="dashboard-tooltip-container">
                      <div className="dashboard-tooltip-header">
                        {t('admin.dashboard_modules.reports.report_setting')}
                      </div>
                      <div>
                        {t(
                          'admin.dashboard_modules.admin_users.report_setting',
                        )}
                      </div>
                    </div>
                  }
                  id={`tooltip-${16}`}
                  arrow
                >
                  <div
                    className="admin-box"
                    onClick={ReportSetting}
                    onMouseEnter={() => (ReportSettingTool = true)}
                    onMouseLeave={() => (ReportSettingTool = false)}
                  >
                    <DashboardIcons.ReportsSVG className="svg-icons" />
                    {toolTipOverlayFunction({
                      show: ReportSettingTool,
                      header: t(
                        'admin.dashboard_modules.reports.report_setting',
                      ),
                      content: t(
                        'admin.dashboard_modules.admin_users.report_setting',
                      ),
                      cardName: t(
                        'admin.dashboard_modules.reports.report_setting',
                      ),
                    })}
                  </div>
                </Tooltip>
              </Col>
            )}
          </Row>
        </div>
      )}
    </Container>
  );
};
const mapStateToProps = ({ user }) => {
  return {
    userData: user.userData,
  };
};
export default withTranslation()(connect(mapStateToProps)(AdminDashboard));
